import { get } from 'lodash';
import CollectionModule from 'client/store/modules/CollectionModule';
import CommandQueueWorkflowApi from 'client/api/v2/CommandQueueWorkflowApi';

export const createCommandQueueWorkflowCollection = () => {
  const collection = new CollectionModule(CommandQueueWorkflowApi, 'id', '-createDate');
  const commandQueueWorkflowCollectionModule = collection.extractModule();

  const getInitialState = () => {
    const { state } = commandQueueWorkflowCollectionModule;
    return {
      ...state,
      refreshKey: 0,
    };
  };

  return {
    namespaced: true,

    state: getInitialState(),

    getInitialState,

    actions: {
      ...commandQueueWorkflowCollectionModule.actions,

      cancelCommandQueue({ commit }, item) {
        return CommandQueueWorkflowApi.cancelCommandQueue(item.workflowInstanceId)
          .then((res) => {
            if (res.status === 204) {
              commit('DELETE_ITEMS', [item.id]);
            }
            return get(res, 'status', null);
          });
      },
    },

    getters: {
      ...commandQueueWorkflowCollectionModule.getters,

      refreshKey(state) {
        return state.refreshKey;
      },
    },

    mutations: {
      ...commandQueueWorkflowCollectionModule.mutations,
    },
  };
};

export default createCommandQueueWorkflowCollection();
